import {CardContent} from "@mui/material"
import {styled} from "@mui/material/styles"

export const PriceContainer = styled("div")`
    display: flex;
`

export const TileCardContent = styled(CardContent)`
    padding: 0 0 1.575rem 0;
    position: relative;
    ${({theme}) =>
        theme.enablingCenteredContent &&
        `
        text-align: center;
  `}
`
